<!--<template>-->
<!--  <v-main>-->
<!--    <v-container fluid fill-height>-->
<!--      <v-layout align-center justify-center>-->
<!--        <v-flex xs12 sm12 md8 offset-lg3 lg6>-->
<!--          <v-card class="elevation-2" >-->
<!--            <v-card-title>Billing Address</v-card-title>-->
<!--          </v-card>-->
<!--          <v-flex xs12 sm8 md8 lg8>-->
<!--            <user-billing-address></user-billing-address>-->
<!--          </v-flex>-->
<!--        </v-flex>-->
<!--      </v-layout>-->
<!--    </v-container>-->
<!--  </v-main>-->
<!--</template>-->
<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8>
          <v-card>
            <v-toolbar>
              <v-toolbar-title class="text--secondary mt-4 mb-4">
                Billing and Usage
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text class="align-center">
              <user-billing-address></user-billing-address>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>
<script>
export default {
  data: () => ({

  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {

    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

